import { bl_fi_mst_entity_label_hdr_RowClass } from '../../../dbschema/bl_fi_mst_entity_label_hdr.model';
import {BaseContainerModel} from '../../base-container.model';


export class EntityLabelHdrContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_label_hdr: bl_fi_mst_entity_label_hdr_RowClass = new bl_fi_mst_entity_label_hdr_RowClass();
}
